import {
    ACCOUNT_CHANGES as PREFIX
} from '../const';
import {
    ACCOUNT_CHANGES_LIST_API
} from '../const/apiMethods'
import {api} from '../api/loginRoutes';
import {createAction} from  './defaults';

const setList = createAction('SET_ITEMS_' + PREFIX);
const setLoading = createAction('SET_LOADING_' + PREFIX);

export const getAccountChanges = (id) => (dispatch) => {
    dispatch( setLoading(true) );
    api(ACCOUNT_CHANGES_LIST_API, {
        target: {account_id: id}
    })
        .then(result => {
            if (!result || !result.account_changes_list) {
                return;
            }
            dispatch( setList(result.account_changes_list) );
        })
        .finally(() => {
            dispatch( setLoading(false) );
        })
};